import React, { useContext, useEffect, useState } from "react";
import LocAnalytics from "./LocAnalytics";
import { useNavigate } from "react-router-dom";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import AppContext from "../../../AppContext";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import GraphAnalytics from "../cost/GraphAnalytics";

const timeModes = [
  { id: "weekToDate", name: "Week To Date" },
  { id: "monthToDate", name: "Month To Date" },
  { id: "today", name: "Today" },
  { id: "custom", name: "Custom" },
];
const IdleAnalytics = () => {
  const navigate = useNavigate();
  const { assets } = useContext(AppContext);
  const [filterState, setFilterState] = useState({
    asset: "~ALL",
    timeMode: "weekToDate",
    startDate: null,
    endDate: null,
  });
  const [popup, setPopup] = useState(false);
  const [assetData, setAssetData] = useState([{ id: "~ALL", name: "ALL" }]);
  const data1 = [
    { x: new Date(2024, 1, 7, 8, 0), y: 100 },
    { x: new Date(2024, 1, 8, 8, 0), y: 120 },
    { x: new Date(2024, 1, 9, 8, 0), y: 110 },
    { x: new Date(2024, 1, 10, 8, 0), y: 140 },
    // Add more data points as needed
  ];

  const data2 = [
    { x: new Date(2024, 1, 7, 8, 0), y: 80 },
    { x: new Date(2024, 1, 8, 8, 0), y: 90 },
    { x: new Date(2024, 1, 9, 8, 0), y: 95 },
    { x: new Date(2024, 1, 10, 8, 0), y: 85 },
    // Add more data points as needed
  ];

  const data = [
    {
      duration: "5 Hrs",
      center: { lat: 25.1972, lng: 55.2744 },
    },
    {
      duration: "2 Hrs",
      center: { lat: 25.1125, lng: 55.1381 },
    },
    {
      duration: "5 Hrs",
      center: { lat: 25.0673, lng: 55.1401 },
    },
    {
      duration: "1 Hrs",
      center: { lat: 25.1949, lng: 55.2432 },
    },
    // Add more objects as needed
  ];

  const setDateRange = (type) => {
    // Get today's date
    let today = new Date();
    let resultDate = new Date();

    switch (type) {
      case "weekToDate":
        resultDate.setDate(today.getDate() - 7);
        break;
      case "monthToDate":
        resultDate.setMonth(today.getMonth() - 1);
        break;
      case "today":
        resultDate.setDate(today.getDate() - 1);
        break;
      default:
        return "Invalid type. Please choose 'week', 'month', or 'day'.";
    }
    setFilterState((pre) => ({
      ...pre,
      endDate: new Date(today),
      startDate: new Date(resultDate),
    }));
  };

  useEffect(() => {
    if (assets)
      setAssetData([
        { id: "~ALL", name: "ALL" },
        ...assets.map((x) => ({
          id: x.id,
          name: x.name,
        })),
      ]);
  }, [assets]);

  return (
    <div className="flex flex-col p-5 h-full overflow-y-hidden">
      <div className="font-medium text-white flex items-center justify-between">
        <div className="flex text-xl items-center gap-2">
          <button type="button" onClick={() => navigate("/analytics")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          IDLE Analysis
        </div>
        <div className="flex gap-2">
          <div id="compo">
            <ComboBox
              id="default-search"
              textField="name"
              data={assetData}
              dataItemKey="id"
              name="asset"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                borderColor: "transparent",
              }}
              clearButton={false}
              className=" block border-gray-400 text-white rounded-lg mb-4 h-8"
              placeholder="Select Asset"
              // onChange={onSearch}
              value={assetData.find((x) => x.id === filterState.asset) || null}
              required
            />
          </div>
          <div className="inline-flex relative rounded group h-8 z-30 w-fit border-black border">
            {timeModes.map((tm) => (
              <button
                type="button"
                className={` md:text-xs text-xxs font-medium transition-all ease-in-out duration-400 text-center w-fit px-3 py-2 ${
                  tm.id === timeModes[0].id
                    ? "rounded-tl rounded-bl"
                    : tm.id === timeModes[timeModes.length - 1].id
                    ? "rounded-tr rounded-br border-l border-blue-900"
                    : "border-l border-blue-900"
                }  ${
                  filterState.timeMode === tm.id
                    ? "bg-blue-900 text-white"
                    : "text-black bg-white"
                }`}
                onClick={() => {
                  setFilterState((pre) => ({ ...pre, timeMode: tm.id }));
                  if (tm.id === "custom") {
                    setFilterState((pre) => ({
                      ...pre,
                      startDate: null,
                      endDate: null,
                    }));
                    setPopup(!popup);
                  } else {
                    setPopup(false);
                    setDateRange(tm.id);
                  }
                }}
                key={tm.id}
              >
                {tm.name}
              </button>
            ))}
            {popup && (
              <div className="bg-slate-800 h-6 w-4 rotate-45 absolute top-8 right-3 z-50"></div>
            )}
            {popup ? (
              <div class=" overflow-y-auto overflow-x-hidden absolute top-10 bg-slate-800 p-2 rounded right-0 z-40 justify-center items-center w-fit ">
                <div className="flex flex-col gap-2 text-sm">
                  <label>Select Date Range</label>
                  <DateTimePicker
                    className="md:h-7 h-5 w-32 md:text-xs text-xxs placeholder:text-white"
                    placeholder="Start Range"
                    width={200}
                    format="dd-MM-yyyy hh:mm a"
                    value={filterState.startDate}
                    onChange={(e) =>
                      setFilterState((pre) => ({
                        ...pre,
                        startDate: e.target.value,
                      }))
                    }
                  />
                  <DateTimePicker
                    className="md:h-7 h-5 md:text-xs text-xxs placeholder:text-white"
                    placeholder="End Range"
                    format="dd-MM-yyyy hh:mm a"
                    width={200}
                    value={filterState.endDate}
                    onChange={(e) =>
                      setFilterState((pre) => ({
                        ...pre,
                        endDate: e.target.value,
                      }))
                    }
                  />
                  {/* <div className="flex gap-2 justify-end">
                    <button
                      type="button"
                      className="bg-indigo-600 md:px-2 text-xs px-1 font-medium md:h-7 h-5 my-auto rounded"
                      // onClick={() => onFilterSubmit()}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="bg-red-500 md:px-2 px-1 text-xs font-medium md:h-7 h-5 my-auto rounded"
                      // onClick={() => onPlayBackClear()}
                    >
                      Close
                    </button>
                  </div> */}
                </div>
              </div>
            ) : null}
          </div>
          <button
            type="button"
            className="bg-indigo-600 md:px-2 text-xs px-1 font-medium md:h-7 h-5 my-auto rounded"
            // onClick={() => onFilterSubmit()}
          >
            Apply
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 max-h-[90vh] pb-2 pt-4 gap-4">
        <div className="flex flex-col gap-2 h-[37vh]">
          <label className="text-sm text-white font-medium">
            Idle Time by Location
          </label>
          <div className="h-full">
            <LocAnalytics id={1} data={data} />
          </div>
        </div>
        <div className=" h-[35vh]">
          {/* <label className="text-sm text-white font-medium">
            By Time - Engine Idle
          </label> */}
          <div className="h-full flex gap-10">
            <div className="flex flex-col w-1/2 gap-3">
              <label className="text-sm text-white font-medium">
                By Time - Engine Idle
              </label>
              <div class="h-52 w-52 text-lg font-semibold self-center text-white flex justify-center items-center rounded-full p-6 bg-teal-500 border-teal-500 border   shadow ">
                3 Hrs
              </div>
            </div>
            <div className="flex flex-col w-1/2 gap-3">
              <label className="text-sm text-white font-medium">
                By Time - Total Idle
              </label>
              <div class="h-52 w-52 text-lg self-center font-semibold text-white flex justify-center items-center rounded-full p-6 bg-teal-500 border border-teal-500 shadow ">
                3 Hrs
              </div>
            </div>
          </div>
        </div>
        <div className="h-[37vh]">
          <label className="text-sm text-white font-medium">
            Total Idle Time vs Engine On
          </label>
          <div className="h-full">
            <GraphAnalytics id={3} data={[data1, data2]} graphType="Column" />
          </div>
        </div>
        <div className="h-[37vh]">
          <label className="text-sm text-white font-medium">
            Idle Time by Location vs Engine On
          </label>
          <div className="h-full">
            <GraphAnalytics id={4} data={[data1, data2]} graphType="Line" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdleAnalytics;
